export enum MessengerInstanceType {
    max = 'v3',
    telegram = 'telegram',
    whatsapp = 'whatsapp',
}

export enum MessengerChatType {
    user = 'user',
    group = 'group',
    channel = 'channel',
    bot = 'bot',
}

export enum MessengerWebhookType {
    incomingMessageReceived = 'incomingMessageReceived',
    outgoingMessageReceived = 'outgoingMessageReceived',
    outgoingAPIMessageReceived = 'outgoingAPIMessageReceived',
    outgoingMessageStatus = 'outgoingMessageStatus',
    stateInstanceChanged = 'stateInstanceChanged',
    quotaExceeded = 'quotaExceeded',
}

export enum MessengerMessageType {
    textMessage = 'textMessage',
    extendedTextMessage = 'extendedTextMessage',
    quotedMessage = 'quotedMessage',
    imageMessage = 'imageMessage',
    videoMessage = 'videoMessage',
    audioMessage = 'audioMessage',
    documentMessage = 'documentMessage',
    stickerMessage = 'stickerMessage',
    locationMessage = 'locationMessage',
    contactMessage = 'contactMessage',
    reactionMessage = 'reactionMessage',
    editedMessage = 'editedMessage',
    deletedMessage = 'deletedMessage',
    pollMessage = 'pollMessage',
}

export enum MessengerMessageStatus {
    delivered = 'delivered',
    read = 'read',
    failed = 'failed',
    noAccount = 'noAccount',
    notInGroup = 'notInGroup',
}
